import React from "react";
import { Mail } from "lucide-react";

const AboutUs = () => {
  const isApp =
    new URLSearchParams(window.location.search).get("source") === "app";

  /* ================= FONT SCALE ================= */
  const pageTitleClass = isApp
    ? "text-lg font-semibold"
    : "text-3xl font-semibold";

  const sectionTitleClass = isApp
    ? "text-sm font-semibold mb-2"
    : "text-lg font-semibold mb-3";

  const bodyTextClass = isApp
    ? "text-sm leading-6"
    : "text-base leading-relaxed";

  const subHeadingClass = isApp
    ? "text-sm font-semibold mt-4 mb-2 text-orange-600"
    : "text-xl font-semibold mt-6 mb-2 text-orange-600";

  return (
    <div className="bg-gray-50 text-gray-800 antialiased min-h-screen">

      {/* ================= HEADER (WEB ONLY) ================= */}
      {!isApp && (
        <header className="bg-white border-b border-gray-200">
          <div className="max-w-4xl mx-auto px-6 py-6">
            <h1 className={pageTitleClass}>About Us</h1>
            <p className="text-sm text-gray-500 mt-1">
              Who we are & our mission
            </p>
          </div>
        </header>
      )}

      {/* ================= CONTENT ================= */}
      <main
        className={`max-w-4xl mx-auto px-5 py-4 bg-white shadow-md rounded-2xl ${
          isApp ? "mt-3 mb-6" : "mt-2 mb-20"
        }`}
      >
        {/* 1. Our Story */}
        <section className="mb-8">
          <h2 className={sectionTitleClass}>Our Story</h2>

          <p className={bodyTextClass}>
            Incorporated in 2026, <strong>Greet India</strong> is committed to
            delivering innovative and meaningful digital experiences.
            We focus on creating high-quality greeting and invitation solutions
            that combine creativity, personalization, and technology.
          </p>

          <p className={`${bodyTextClass} mt-3`}>
            Our platform enables users to create customized greetings,
            invitations, and digital content that connect people emotionally
            while maintaining professional design standards.
          </p>

          <p className={`${bodyTextClass} mt-3`}>
            We believe in innovation, reliability, and delivering value-driven
            services that enhance communication across families, businesses,
            and communities.
          </p>
        </section>

        {/* 2. Our Mission */}
        <section className="mb-8">
          <h2 className={sectionTitleClass}>Our Mission</h2>
          <p className={bodyTextClass}>
            Our mission is to simplify digital greetings and communication by
            providing intuitive tools, elegant templates, and secure
            technology that empowers users to express themselves effortlessly.
          </p>
        </section>

        {/* 3. What We Offer */}
        <section className="mb-8">
          <h2 className={sectionTitleClass}>What We Offer</h2>
          <ul className={`list-disc list-inside space-y-1 ${bodyTextClass}`}>
            <li>Personalized digital greeting creation</li>
            <li>Custom invitation design solutions</li>
            <li>Secure cloud-based media management</li>
            <li>Modern and responsive user experience</li>
            <li>High-quality templates and design tools</li>
          </ul>
        </section>

        {/* 4. Our Values */}
        <section className="mb-8">
          <h2 className={sectionTitleClass}>Our Core Values</h2>
          <ul className={`list-disc list-inside space-y-1 ${bodyTextClass}`}>
            <li>Innovation and creativity</li>
            <li>User-centric design</li>
            <li>Data privacy and security</li>
            <li>Transparency and trust</li>
            <li>Continuous improvement</li>
          </ul>
        </section>

        {/* 5. Meet Our Team */}
        <section>
          <h2 className={sectionTitleClass}>Meet Our Team</h2>
          <p className={`${bodyTextClass} mb-4`}>
            Our professionals are backed by rich industry experience and strive
            to deliver excellence in every product and service.
          </p>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
            {/* Team Member 1 */}
            <div className="p-4 border border-gray-200 rounded-xl shadow-sm">
              <h3 className="font-semibold text-gray-900">
                GreetIndia9
              </h3>
              {/* <p className="text-sm text-gray-600">CEO / Founder</p> */}
              <p className="text-sm text-gray-600 mt-1 flex items-center gap-2">
                <Mail className="w-4 h-4" />
                greetindia9@gmail.com
              </p>
            </div>

            {/* Team Member 2 */}
            {/* <div className="p-4 border border-gray-200 rounded-xl shadow-sm">
              <h3 className="font-semibold text-gray-900">
                ACD
              </h3>
              <p className="text-sm text-gray-600">Marketing Director</p>
              <p className="text-sm text-gray-600 mt-1">
                📞 +91 98xxx xxxxx
              </p>
            </div> */}
          </div>
        </section>
      </main>
    </div>
  );
};

export default AboutUs;
